export const common = {
  signIn: "Iniciar sesión",
  inbox: "Bandeja de entrada",
  create: "Crear",
  home: "Inicio",
  listings: "Anuncios",
  myPage: "Mi página",
  close: "Cerrar",
  cancel: "Cancelar",
  save: "Guardar",
  delete: "Eliminar",
  edit: "Editar",
  tryAgain: "Intentar de nuevo",
  toStartPage: "Ir a la página de inicio",
  more: "Más",
  search: "Buscar",
  loading: "Cargando…",
  free: "Gratis",
  price: "Precio",
  kr: "kr",
  sold: "Vendido",
  paused: "Pausado",
  today: "Hoy",
  yesterday: "Ayer",
  unread: "sin leer",
  openOnWeb: "Abrir en la web",
  webBanner: "Las compras y mejoras se hacen en sellavo.com",
  quickMenu: "Menú rápido",
  language: "Idioma",
  country: "País",
  sellCountry: "País de venta",
  sellCountryHint: "Determina dónde se vende el artículo y qué localidades se muestran.",
} as const;
